import React from 'react';
import { adminTheme } from './adminTheme';

type InfoCardProps = {
  title: string;
  body: string;
};

export default function InfoCard({ title, body }: InfoCardProps) {
  return (
    <div
      style={{
        background: adminTheme.color.surface,
        border: `1px solid ${adminTheme.color.border}`,
        borderRadius: adminTheme.radius.md,
        padding: adminTheme.space.xl,
        display: 'flex',
        flexDirection: 'column',
        gap: adminTheme.space.sm,
        boxShadow: adminTheme.shadow.sm,
      }}
    >
      <h3
        style={{
          margin: 0,
          fontSize: adminTheme.type.titleSm,
          lineHeight: 1.35,
          color: adminTheme.color.text,
          letterSpacing: '-0.01em',
        }}
      >
        {title}
      </h3>

      <p
        style={{
          margin: 0,
          color: adminTheme.color.textMuted,
          lineHeight: 1.65,
          fontSize: adminTheme.type.body,
        }}
      >
        {body}
      </p>
    </div>
  );
}